"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowLineageCountsQueryWrapper = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var FlowLineageCountsFilteredByFieldQueryGql_1 = require("../../queries/FlowLineageCountsFilteredByFieldQueryGql");
var FlowLineageCountsQueryGql_1 = require("../../queries/FlowLineageCountsQueryGql");
var LineageCountsFunctions_1 = require("../lineage/LineageCountsFunctions");
function createUnfilteredCounts(data) {
    var _a, _b, _c;
    var flow = data.flows && data.flows[0];
    if (flow
        && flow.upstreamDatabasesConnection
        && flow.upstreamTablesConnection
        && flow.upstreamFlowsConnection
        && flow.upstreamDatasourcesConnection
        && flow.downstreamDashboardsConnection
        && flow.downstreamDatabasesConnection
        && flow.downstreamTablesConnection
        && flow.downstreamFlowsConnection
        && flow.downstreamDatasourcesConnection
        && flow.downstreamWorkbooksConnection
        && flow.downstreamSheetsConnection
        && flow.downstreamMetricsConnection
        && flow.downstreamOwnersConnection) {
        return {
            filteredFieldName: null,
            upstreamDatabases: flow.upstreamDatabasesConnection.totalCount,
            upstreamTables: flow.upstreamTablesConnection.totalCount,
            upstreamVirtualConnections: ((_a = flow.upstreamVirtualConnectionsConnection) === null || _a === void 0 ? void 0 : _a.totalCount) || 0,
            upstreamVirtualConnectionTables: ((_b = flow.upstreamVirtualConnectionTablesConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            upstreamFlows: flow.upstreamFlowsConnection.totalCount,
            upstreamDatasources: flow.upstreamDatasourcesConnection.totalCount,
            downstreamDashboards: flow.downstreamDashboardsConnection.totalCount,
            downstreamDatabases: flow.downstreamDatabasesConnection.totalCount,
            downstreamTables: flow.downstreamTablesConnection.totalCount,
            downstreamFlows: flow.downstreamFlowsConnection.totalCount,
            downstreamDatasources: flow.downstreamDatasourcesConnection.totalCount,
            downstreamLenses: ((_c = flow.downstreamLensesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            downstreamWorkbooks: flow.downstreamWorkbooksConnection.totalCount,
            downstreamSheets: flow.downstreamSheetsConnection.totalCount,
            downstreamMetrics: flow.downstreamMetricsConnection.totalCount,
            downstreamOwners: flow.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
function createFilteredCounts(data) {
    var _a, _b, _c;
    var flow = data.flows && data.flows[0];
    var outputStep = flow && flow.outputSteps && flow.outputSteps[0];
    var filteredField = outputStep && outputStep.filteredFieldsConnection &&
        outputStep.filteredFieldsConnection.nodes[0];
    if (outputStep
        && filteredField
        && filteredField.upstreamDatabasesConnection
        && filteredField.upstreamTablesConnection
        && filteredField.upstreamFlowsConnection
        && filteredField.upstreamDatasourcesConnection
        && filteredField.downstreamDashboardsConnection
        && filteredField.downstreamDatabasesConnection
        && filteredField.downstreamTablesConnection
        && filteredField.downstreamFlowsConnection
        && filteredField.downstreamDatasourcesConnection
        && filteredField.downstreamLensesConnection
        && filteredField.downstreamWorkbooksConnection
        && filteredField.downstreamSheetsConnection
        && filteredField.downstreamMetricsConnection
        && filteredField.downstreamOwnersConnection) {
        return {
            filteredFieldName: (_a = filteredField === null || filteredField === void 0 ? void 0 : filteredField.name) !== null && _a !== void 0 ? _a : null,
            upstreamDatabases: filteredField.upstreamDatabasesConnection.totalCount,
            upstreamTables: filteredField.upstreamTablesConnection.totalCount,
            upstreamVirtualConnections: ((_b = filteredField.upstreamVirtualConnectionsConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            upstreamVirtualConnectionTables: ((_c = filteredField.upstreamVirtualConnectionTablesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            upstreamFlows: filteredField.upstreamFlowsConnection.totalCount,
            upstreamDatasources: filteredField.upstreamDatasourcesConnection.totalCount,
            downstreamDashboards: filteredField.downstreamDashboardsConnection.totalCount,
            downstreamDatabases: filteredField.downstreamDatabasesConnection.totalCount,
            downstreamTables: filteredField.downstreamTablesConnection.totalCount,
            downstreamFlows: filteredField.downstreamFlowsConnection.totalCount,
            downstreamDatasources: filteredField.downstreamDatasourcesConnection.totalCount,
            downstreamLenses: filteredField.downstreamLensesConnection.totalCount,
            downstreamWorkbooks: filteredField.downstreamWorkbooksConnection.totalCount,
            downstreamSheets: filteredField.downstreamSheetsConnection.totalCount,
            downstreamMetrics: filteredField.downstreamMetricsConnection.totalCount,
            downstreamOwners: filteredField.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
var FlowLineageCountsQueryWrapper = function (props) {
    var _a = React.useContext(data_catalog_shared_1.FeatureFlagsContext), publishedConnectionsLineageEnabled = _a.publishedConnectionsLineageEnabled, lensLineageEnabled = _a.lensLineageEnabled;
    var keys = Object.keys(props.selectedKeys);
    if (keys.length > 0) {
        var selectedFieldId = keys[0];
        return (React.createElement(react_apollo_1.Query, { query: FlowLineageCountsFilteredByFieldQueryGql_1.FlowLineageCountsFilteredByFieldQueryGql, variables: {
                flowVizportalUrlId: props.flowVizportalUrlId,
                outputStepId: props.selectedOutputStepId,
                selectedFieldId: selectedFieldId,
                publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
                lensLineageEnabled: lensLineageEnabled,
            } }, function (result) { return LineageCountsFunctions_1.renderFilteredLineageCounts(result, createUnfilteredCounts, createFilteredCounts, props.children); }));
    }
    else {
        return (React.createElement(react_apollo_1.Query, { query: FlowLineageCountsQueryGql_1.FlowLineageCountsQueryGql, variables: {
                flowVizportalUrlId: props.flowVizportalUrlId,
                publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
                lensLineageEnabled: lensLineageEnabled,
            } }, function (result) { return LineageCountsFunctions_1.renderUnfilteredLineageCounts(result, createUnfilteredCounts, props.children); }));
    }
};
exports.FlowLineageCountsQueryWrapper = FlowLineageCountsQueryWrapper;
//# sourceMappingURL=FlowLineageCountsQueryWrapper.js.map